export default class Prices {

    constructor() {}


    static get currency() {
        let currencies = [{
                name: 'EUR',
                value: '&euro;'
            },
            {
                name: 'GBP',
                value: '&pound;'
            },
            {
                name: 'USD',
                value: '$'
            },
            {
                name: 'PLN',
                value: 'zł'
            },
        ];

        return currencies.find((item) => {
            return item.name === $('#personalizator__currency').data('currency');
        }).value;
    }

    static get exchangeRate() {
        return $('#personalizator__currency').data('rate');
    }

    static showPrice(price) {
        return `${this.formatMoney((parseFloat(price) / (this.exchangeRate ? parseFloat(this.exchangeRate) : 1)), 2, ',', ' ')} ${this.currency} netto`;
    }

    static preparePrice(priceText) {
        let precision = Math.pow(10, 2);
        return (Math.ceil(parseFloat(priceText) * precision) / precision);
    }

    static formatMoney(n, c, d, t) {
        var c = isNaN(c = Math.abs(c)) ? 2 : c,
            d = d === undefined ? "." : d,
            t = t === undefined ? "," : t,
            s = n < 0 ? "-" : "",
            i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }

    static calculatePrice() {

        let printPrice = 0;
        const prices = JSON.parse($('#personalizator__prices').val());


        $('.personalizator__element').each((index, element) => {

            let el = JSON.parse($(element).data('element'));

            if (el.type === 'number') {

                if (el.size > 80) {

                    printPrice += this.preparePrice(prices['number_big']);

                } else {

                    printPrice += this.preparePrice(prices['number']);

                }

            } else {

                printPrice += this.preparePrice(prices[el.type]);

            }

        });

        return printPrice;


    }

    static updatePrices() {
        const tshirtPrice = this.preparePrice($(`#variant_${$('.variant-sizes').val()}`).data('price'));
        const printPrice = this.calculatePrice();

        const qty = $('#personalizator__qty').val();

        const tshirtElement = '#personalizator__product-tshirt';
        const printElement = '#personalizator__print-price';
        const summaryElement = '#personalizator__summary-price';

        $(tshirtElement).text(Prices.showPrice(tshirtPrice));
        $(printElement).text(Prices.showPrice((printPrice)));
        $(summaryElement).text(Prices.showPrice(((tshirtPrice * qty) + (printPrice * qty))));

        return true;
    }
}
